<template>
    <div>

        <div class="Section Section-Title">
            <h2 class="Product-Title test-product_title">{{ product.name }}</h2>

            <p class="Product-Price">
                {{ base_product_price | formatCurrency(active_module.currency) }}
            </p>

            <ul class="Description-Nav" v-if="product.description">
                <li class="Description-Nav-Item Description-Nav-Item--Active pointer">{{ $t('product.description')}}</li>
                <li class="Description-Nav-Item disabled pointer">{{ $t('product.more_info')}}</li>
            </ul>
        </div>


        <div  class="Section Section--Top-Bordered Section-Description" v-if="product.description">
            <span transition="fade" class="Product-Description" v-html="description"></span>
            <!-- <span class="text-primary pointer" v-show="showMore" @click="full= !full">{{ full ? $t('product.less') : $t('product.more') }}</span>
            <small class="text-primary pointer" v-show="showMore" @click="full= !full">{{ full ? '▲':'▼' }}</small> -->
        </div>

        <div class="Section Section--Top-Bordered Section-Modifiers" v-if="product.modifiers && product.modifiers.length || product.price_list">
            <list-price v-if="product.price_list" @change="change_price_details" :label="product.price_list_data.label" :values="product.price_list_data.values" :currency="active_module.currency"></list-price>
            <modifier-list v-if="product.modifiers" :modifiers="product.modifiers"></modifier-list>
        </div>


        <div class="Section Section--Top-Bordered Section-AddToCart">
            <div class="Details-Container Centered">

                <select v-if="product.is_disabled == ''" class="AddToCartQty test-product_quantity_selector" @change="update_quantity">
                    <option v-for="n in 100" :value="n">{{ n }}</option>
                </select>

                <div v-if="product.is_disabled == ''">
                    <button class="AddToCartButton" id="test-add_to_cart" @click.prevent="add_product_to_cart">
                        {{ $t('product.cta_addtocart', {price: ''}) }} <span class="AddToCart-Price">{{active_price_with_currency }}</span>
                    </button>
                </div>
                <span v-if="product.is_disabled === 'x'" class="Product-Disabled">{{ $t('product.title_closedforsale') }}</span>

            </div>

        </div>

        <div class="Section Section-ContinueShopping">
            <span class="pointer" @click="$router.push({name: 'List', params: { module_id: active_module.module_id, scrollParent: true }})">{{ $t('cart.cta_goback') }}</span>
        </div>

        <div v-if="product.is_disabled === ''" class="Section Section--Top-Bordered Section-CartResume">
            <div class="left" style="display: flex; " v-if="is_active">
                <img class="decorator" height="35" src="/static/img/bag_icon.svg" alt="Bag">
                <div>
                    <span style="color: #04BE5B;">{{ cartItems }} {{ $tc('cart.item', cartItems)}} </span><span v-if="false">{{ $t('cart.in_your_cart')}}</span><br>
                    <span>{{ $t('cart.title_totalamount') }} {{ amount_with_modifiers_normal | formatCurrency(active_module.currency) }}</span>
                </div>

            </div>
            <input v-show="is_active" @click="$router.push({name: 'Checkout', params: { module_id: active_module.module_id }})" class="cta-cart-button btn btn-default" type="button" :value="$t('product.cta_checkoutpage')">

            <p id="test-cart-is-empty-message" class="Cart-Empty" v-show="!is_active">{{ $t('cart.warning_empty') }}</p>
        </div>


    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ListPrice from './price-list.vue';
  import ModifierList from './modifier-list.vue';
  import ProductDescription from './product-description.vue';

  export default {
    props: ['is_active'],

    data () {
      return {
        full: false
      };
    },

    components: {
      ListPrice,
      ModifierList,
      ProductDescription
    },

    computed: {
      ...mapGetters([
        'cart',
        'product',
        'active_module',
        'active_product_price',
        'active_product_list_price',
        'amount_with_modifiers_normal'
      ]),

      showMore () {
        return this.product.description.lastIndexOf('</p>') > 450;
      },

      description () {
        return this.product.description;
        // if (this.full) {
        //   return this.product.description;
        // }
        // let str_end = this.product.description.indexOf('</p>');
        // return this.product.description.substr(0, str_end);
      },

      cartItems () {
        return this.cart.reduce((a, b) => {
          return a + parseInt(b.quantity);
        }, 0);
      },

      base_product_price () {
        const calc = this.product.price_list ? this.active_product_list_price : this.product.price;
        // console.log('Calc:', calc);
        return calc;
      },

      base_price_with_currency () {
        return this.$options.filters.formatCurrency(
          this.base_product_price,
          this.active_module.currency
        );
      },

      active_price_with_currency () {
        return this.$options.filters.formatCurrency(
          this.active_product_price,
          this.active_module.currency
        );
      },
    },

    methods: {
      ...mapActions([
        'info_product',
        'set_active_product_price',
        'add_active_product_to_cart',
        'set_active_product_quantity',
        'set_active_product_price_details'
      ]),

      add_product_to_cart () {
        if (!this.product.price_list) {
          this.set_active_product_price_details({
            price_list: false,
            price: this.product.price,
            price_partial: this.product.price_partial
          });
        }
        this.add_active_product_to_cart();
      },

      change_price_details (payload) {
        let data = {};
        if (this.product.price_list) {
          data = {price_list: true, price_list_data: payload};
        } else {
          data = {price_list: false, price: this.product.price, price_partial: this.product.price_partial};
        }
        this.set_active_product_price_details(data);
        this.set_active_product_price(payload.value);
      },

      update_quantity (e) {
        this.set_active_product_quantity({quantity: e.target.value});
      }
    }
  };
</script>

<style scoped>

  .disabled {
    color: #D8D8D8;
    cursor: default;
  }

  .Product-Title {
    margin: 0;
    font-family: 'Roboto Condensed';
    font-weight: 400;
    font-size: 2.3em;
    color: black;
  }

  .Product-Price {
    font-family: 'Roboto Condensed';
    font-weight: 400;
    font-size: 2.2em;
    color: #04BE5B;
    margin-top: .25em;
    margin-bottom: .4em;
  }

    .Description-Nav {
        margin: 0;
        padding: 0;
        display: flex;
        list-style: none;
        font-family: 'Roboto';
        font-weight: 400;
        margin-bottom: -1px;
        color:#595959;
    }

    .Description-Nav-Item {
        padding: 4px 0;
        margin-right: 20px;
    }

    .Description-Nav-Item--Active {
        border-bottom: 2px solid royalblue;
    }

    .Product-Description {
        color:#595959;
        font-family: 'Roboto';
        font-weight: 300;
        font-size: 1.1em;
        line-height: 2.2em;
    }

    .Section--Top-Bordered {
        border-top: 1.2px solid #D8D8D8;
        padding: 4%;
    }

    .Section {
        padding: 4%;

    }
    .Section-Title {
        padding-bottom: 0;
    }

    .Section-AddToCart {
        display: flex;
        align-content: center;
        justify-content: center;
        padding: 5%;
        padding-bottom: 1%;
        padding-top: 6%;
    }

    .Centered {
        display: flex;
        font-family: 'Roboto';
        color: #737373;
        font-weight: 400;
    }

    .AddToCart-Price {
        color: #04BE5B;
    }

    .AddToCartButton, .AddToCartQty  {
        border-radius: 5px;
        border-width: 2px;
        border-color: #4D4D4D;
        font-size: 1.2em;
        outline: none;
      }

    .AddToCartQty  {
        margin-right: 5px;
    }

    .AddToCartButton {
        padding: 14px 15px;
        /* min-width: 230px; */
        background: white;
    }

    .Product-Disabled, .Cart-Empty {
        font-family: 'Roboto Condensed';
        font-size: 1.2em;
        font-weight: 500;
    }

    .Section-ContinueShopping {
        display: flex;
        align-content: center;
        justify-content: center;
        color: steelblue;
        font-family: 'Roboto Condensed';
        font-weight: 500;
        padding-top: 2%;
        padding-bottom: 6%;
    }

    .Section-CartResume {
        display: flex;
        justify-content: space-around;
        padding: 5% 2%;
    }

    .left, .right {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Roboto Condensed';
        font-size: 1.15em;
        font-weight: 300;
        width: 50%;
    }

    .right {
        padding-left: 2%;
    }

    .Continue-Shopping {
        padding: 0%;
        padding-bottom: 5%;
    }

    .decorator {
        margin-right: 7px;
    }

    @media screen and (max-width: 400px) {
        .decorator {
            /* display: none; */
        }
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    /* .Section-CartResume .left {
        border-right: 1px solid gray;
    } */
</style>



// WEBPACK FOOTER //
// buy-box.vue?561f611e